module.exports = __webpack_public_path__ + "static/media/CheckCircleFilled.f4b71a5a.svg";